import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeProvider as CSThemeProvider } from '@csinstruments/cs-react-theme'
import { environment } from '../helpers/environment'

type Props = {
  children: ReactNode
}

const ThemeProvider: React.FC<Props> = ({ children }: Props) => {
  const { i18n } = useTranslation('common')
  const themeSelected = environment.STAGE === 'neutral' ? 'neutralLight' : 'csLight'
  return (
    <CSThemeProvider theme={themeSelected} language={i18n.language.toLowerCase()}>
      {children}
    </CSThemeProvider>
  )
}

export default ThemeProvider
